/**
 * Clamp a percentage into the 0-100 range the bar can display. NaN (e.g. from a zero-denominator
 * division upstream) collapses to 0 rather than propagating into styles and ARIA values.
 * @param value The raw percentage.
 * @returns The clamped percentage.
 */
export const clampPercentage = (value: number): number => (Number.isNaN(value) ? 0 : Math.min(100, Math.max(0, value)));
